import React, { forwardRef, useImperativeHandle, useMemo } from 'react';
import {
  createFocusHandle,
  createOnBlur,
  FilterInputProps,
  FilterOption,
  FocusRef,
  Form,
  useTableStoreValue,
} from '@atlas-frontend/sdk';
import styled from 'styled-components';
import { LogDataFilterFormContent } from './LogDataFilterFormContent';
import { DEFAULT_VALUES, LogDataSchema, LogDataType } from './types';
import { deserializeLogDataFilters } from './utils';

const DEFAULT_OPTIONS: FilterOption[] = [];

export const LogDataFilterInput = forwardRef<FocusRef, FilterInputProps>(
  (props, ref) => {
    const { header, onBlur } = props;
    const { id, getFilterValue } = header.column;
    const columnId = id as keyof LogDataType;
    const filterId = `${columnId}-filter-input`;
    const [options] = useTableStoreValue('options');

    useImperativeHandle(ref, () => createFocusHandle(`${id}-0-attribute`));

    const handleOnBlur = useMemo(
      () => createOnBlur<HTMLDivElement>(filterId, onBlur),
      [filterId, onBlur]
    );
    const defaultValue = useMemo(() => {
      const filters = deserializeLogDataFilters(getFilterValue() as string);
      return {
        ...DEFAULT_VALUES,
        [columnId]: filters,
      };
    }, [columnId, getFilterValue]);

    return (
      <Form schema={LogDataSchema} defaultValues={defaultValue}>
        <Scrollable className={filterId} onBlur={handleOnBlur}>
          <LogDataFilterFormContent
            header={header}
            name={columnId}
            options={options?.[columnId] ?? DEFAULT_OPTIONS}
          />
        </Scrollable>
      </Form>
    );
  }
);

const Scrollable = styled.div`
  max-height: calc(100vh - 320px);
  overflow: auto;
`;
